import React, { useCallback, useEffect, useState} from "react";
import { useUser } from "../UserContext";
import { useNavigate } from "react-router-dom";
import { Dropdown, Button } from "react-bootstrap";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { fetchUnreadChatCount, markChatMessagesRead } from "../api/api";

const UserMenu = ({ handleLogout }) => {
    const { user } = useUser();
    const [unreadCount, setUnreadCount] = useState(0);
    // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const refreshUnreadCount = useCallback(async () => {
        if (!user) return;
        try {
            const count = await fetchUnreadChatCount();
            setUnreadCount(count);
        } catch (error) {
            console.error('Error fetching unread chat count:', error);
        }
    }, [user]);

    useEffect(() => {
        refreshUnreadCount();
        const interval = setInterval(refreshUnreadCount, 30000);
        return () => clearInterval(interval);
    }, [refreshUnreadCount]);

    const handleProfileClick = () => {
        navigate('/profile');
    };

    const handleChatClick = async () => {
        try {
            await markChatMessagesRead();
            setUnreadCount(0);
        } catch (error) {
            console.error('Error clearing unread chat count:', error);
        }
        navigate('/chat');
    };

    if (!user) {
        return (
            <div className="user-menu">
                <Button variant="primary" onClick={() => navigate('/login')}>Login</Button>
            </div>
        );
    }

    return (
        <div className="user-menu">
            <Button
                variant="link"
                className="chat-unread-button"
                onClick={handleChatClick}
                title="Chat"
            >
                <i className="bi bi-chat-dots" style={{ fontSize: '1.35rem' }}></i>
                {unreadCount > 0 && (
                    <span className="chat-unread-badge">{unreadCount}</span>
                )}
            </Button>
            <Dropdown align="end">
                <Dropdown.Toggle variant="link" id="dropdown-user-menu" className="d-flex align-items-center">
                    <i className="bi bi-person-circle me-2" style={{ fontSize: '1.5rem' }}></i>
                    {/*<Image src="https://via.placeholder.com/30" roundedCircle alt="User Icon" className="me-2" />*/}
                    <span>{user.username}</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu" variant="light">
                    <Dropdown.Item onClick={handleProfileClick}>Profile</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default UserMenu;